import { render, staticRenderFns } from "./PeriodizationTypeSelector.vue?vue&type=template&id=20b6873c"
import script from "./PeriodizationTypeSelector.vue?vue&type=script&lang=ts"
export * from "./PeriodizationTypeSelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports